module.exports = __webpack_public_path__ + "img/benefit-4.173ed554.svg";